export default [
    {
        "name": "MAJOR",
        "interval": [
            2,
            2,
            1,
            2,
            2,
            2
        ]
    },
    {
        "name": "MAJOR PENTATONIC",
        "interval": [
            2,
            2,
            3,
            2
        ]
    },
    {
        "name": "MAJOR BLUES",
        "interval": [
            2,
            1,
            1,
            3,
            2
        ]
    },
    {
        "name": "MINOR",
        "interval": [
            2,
            1,
            2,
            2,
            1,
            2
        ]
    },
    {
        "name": "HARMONIC MINOR",
        "interval": [
            2,
            1,
            2,
            2,
            1,
            3
        ]
    },
    {
        "name": "MELODIC MINOR",
        "interval": [
            2,
            1,
            2,
            2,
            2,
            2
        ]
    },
    {
        "name": "MINOR PENTATONIC",
        "interval": [
            3,
            2,
            2,
            3
        ]
    },
    {
        "name": "MINOR BLUES",
        "interval": [
            3,
            2,
            1,
            1,
            3
        ]
    },
    {
        "name": "HUNGARIAN MINOR",
        "interval": [
            2,
            1,
            3,
            1,
            1,
            3
        ]
    },
    {
        "name": "JAPANESE",
        "interval": [
            2,
            1,
            4,
            1
        ]
    },
    {
        "name": "EGYPTIAN",
        "interval": [
            2,
            3,
            2,
            3
        ]
    }
]